import React from "react";
import PropTypes from "prop-types";
import styles from "./RemoveGroupModal.module.css";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";

/**
 * Interactive component. Modal used to remove a user from a group
 */

export function RemoveGroupModal({ isOpen, onClose, onClick, groupInfo }) {
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="REMOVE FROM GROUP"
        closeBtn="none"
        className={styles.modal}
      >
        <div className={styles.contentContainer}>
          <p className={styles.contentText}>
            Are you sure you would like to remove the user from the following
            group?
          </p>

          <div className={styles.headerGrid}>
            <div className={styles.headerItem}>Group Name</div>
            <div className={styles.headerItem}>Group Type</div>
          </div>
          <div className={styles.gridContainer}>
            <div className={styles.gridItem}>{groupInfo.name}</div>
            <div className={styles.gridItem}>{groupInfo.groupType}</div>
          </div>
        </div>
        <div className={styles.btnContainer}>
          <ModalActionBar
            children={
              <div className={styles.btnDiv}>
                <button
                  type="button"
                  className={styles.cancelBtn}
                  onClick={onClose}
                >
                  CANCEL
                </button>
                <button
                  type="button"
                  className={styles.removeBtn}
                  onClick={onClick}
                >
                  REMOVE
                </button>
              </div>
            }
          />
        </div>
      </Modal>
    </div>
  );
}

RemoveGroupModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when create all is clicked
   */
  onClick: PropTypes.func,
  /**
   * Object with the groups info.
   */
  groupInfo: PropTypes.shape({
    name: PropTypes.string,
    groupType: PropTypes.string,
    status: PropTypes.string,
    pluginType: PropTypes.string,
    notes: PropTypes.string,
  }),
};
